import React from "react";

const Header = () => {
  return (
    <div className="header">
      <h1 className="rubik-dirt-regular">החווה של חן</h1>
      <h2 className="rubik-dirt-regular">
        רכיבה טיפולית, פינת חי ואירועים פרטיים
      </h2>
    </div>
  );
};

export default Header;
